import { accountAgeCalculator, sanitizeDatalayerPayload, ternaryHandler, updateDateFormat } from './common';

export const pageViewACDLKeyGenerator = (datalayer: Record<string, string>) => {
  if (datalayer) {
    const payload = {
      metadata: {
        allow_marketing: true, //always true if ACDL enabled
        site_id: ternaryHandler(datalayer['env_site_id']),
        language_domain: ternaryHandler(datalayer['env_site_id']),
        platform: ternaryHandler(datalayer['env_platform']),
        server_id: ternaryHandler(datalayer['env_server_id']),
        session_id: ternaryHandler(datalayer['sessionId']),
        latitude: ternaryHandler(datalayer['browser_akamai_loc_lat']),
        longitude: ternaryHandler(datalayer['browser_akamai_loc_long']),
        geo_country: ternaryHandler(datalayer['browser_akamai_loc_country']),
        geo_state: ternaryHandler(datalayer['browser_akamai_loc_state']),
        geo_city: ternaryHandler(datalayer['browser_akamai_loc_city']),
      },
      page: {
        name: window.location.host + window.location.pathname + window.location.hash,
        section: 'Property Internet',
        template: 'PPV5',
        experience: ternaryHandler(datalayer['page_portal_age_experience']),
        property_internet_details: ternaryHandler(datalayer['prop_internet_mac']),
      },
      user: {
        alt_customer_id: ternaryHandler(datalayer['altCustId'], ternaryHandler(datalayer['mr_id_alternate'])),
        authentication_status: ternaryHandler(datalayer['memState']),
        member_level: ternaryHandler(datalayer['mr_prof_member_program_level']),
        member_city: ternaryHandler(datalayer['mr_prof_address_city']),
        member_state: ternaryHandler(datalayer['mr_prof_address_state']),
        member_country: ternaryHandler(datalayer['mr_prof_address_country']),
        upcoming_stay: ternaryHandler(datalayer['mr_prof_upcoming_stay']),
        stay_in_progress: ternaryHandler(datalayer['mr_prof_stay_in_progress']),
        cc_all: ternaryHandler(datalayer['mr_prof_cc_all']),
        nights_booked_this_year: ternaryHandler(datalayer['mr_prof_nights_booked_this_year']),
        nights_to_renew_current_member_level: ternaryHandler(datalayer['mr_prof_nights_to_renew_current']),
        points_balance: ternaryHandler(datalayer['mr_prof_points_balance']),
        member_join_date: updateDateFormat(ternaryHandler(datalayer['mr_prof_join_date']) as string),
        account_age: accountAgeCalculator(datalayer ?? {}),
        enrollment_source: ternaryHandler(datalayer['mr_enrollment_source']),
      },
      products: {
        id: ternaryHandler(datalayer['prop_marsha_code']),
        property_id: ternaryHandler(datalayer['prop_marsha_code']), //to check if this should be same as product_id
        brand: ternaryHandler(datalayer['prop_brand_name']),
        property_tier: ternaryHandler(datalayer['prop_brand_tier']),
        property_code: ternaryHandler(datalayer['prop_brand_code']),
      },
    };

    const cleanedPayload = sanitizeDatalayerPayload(payload);

    const finalPayload = {
      metadata: cleanedPayload['metadata'],
      page: cleanedPayload['page'],
      user: cleanedPayload['user'],
      ...((cleanedPayload['products'] as object) && { products: [cleanedPayload['products']] }),
    };

    return finalPayload;
  }
  return {};
};
